import {
  Alert,
  Box,
  Modal,
  ModalContent,
  Typography
} from "@dealer-center/core-components";
import { useDeleteDepartment } from "@dealer-center/ddc-pages-departments-fetch";
import { useOutletContext } from "react-router-dom";
import { useState } from "react";
import { parseErrorMessages } from "./utils";

import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import type { DeleteDepartmentModal } from "../Departments";
interface DeleteDepartmentProps extends DeleteDepartmentModal {
  hideModal: () => void;
}
export const DeleteDepartment = ({
  hideModal,
  modalToShow,
  selected
}: DeleteDepartmentProps) => {
  const mutation = useDeleteDepartment();
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();

  const handleDelete = () => {
    setErrorMessages([]); // Clear previous errors
    mutation
      .mutateAsync({
        accountId: accountEntity.id,
        department: selected.type
      })
      .then(() => hideModal())
      .catch(async error => {
        console.error("Failed to delete department:", error);
        setErrorMessages(
          await parseErrorMessages(
            error,
            "Failed to delete department. Please try again."
          )
        );
      });
  };

  return (
    <Modal
      footer={{
        primary: {
          label: "Delete",
          disabled: mutation.isPending,
          action: handleDelete,
          isLoading: mutation.isPending
        },
        options: {
          label: "Cancel",
          action: () => hideModal(),
          disabled: mutation.isPending
        }
      }}
      header="Delete Department"
      show={modalToShow === "delete"}
      size="large"
      onHide={() => !mutation.isPending && hideModal()}
    >
      <ModalContent>
        {errorMessages.length > 0 && (
          <Alert sx={{ mb: 2 }} type="error">
            <Box component="ul" sx={{ m: 0, pl: 2 }}>
              {errorMessages.map(msg => (
                <li key={msg}>{msg}</li>
              ))}
            </Box>
          </Alert>
        )}
        <Typography variant="list-md">Name: {selected.label}</Typography>
        <Typography variant="list-md">Type: {selected.type}</Typography>
        <Typography sx={{ color: "text.secondary", mt: 2 }} variant="body-sm">
          This action cannot be undone and will remove all associated department
          data.
        </Typography>
      </ModalContent>
    </Modal>
  );
};
